export default __webpack_public_path__ + "static/media/undraw_Coding5.c70fb857.svg";